import type { ErrorInfo } from "../../../types";
import { ErrorStatusBadge } from "../../atoms/ErrorStatusBadge";
import { ErrorMessage } from "../../molecules/ErrorMessage";
import { ErrorDetails } from "../../molecules/ErrorDetails";
import { ErrorActions } from "../../molecules/ErrorActions";
import { getErrorIcon } from "../../../utils/errorHandlers";

interface ErrorDisplayProps {
  errorInfo: ErrorInfo;
  error: unknown;
  onRetry: () => void;
  onGoBack: () => void;
}

export const ErrorDisplay = ({
  errorInfo,
  error,
  onRetry,
  onGoBack,
}: ErrorDisplayProps) => {
  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      <div className="max-w-md w-full surface-primary p-6 rounded-lg shadow-lg">
        <div className="text-center">
          <div className="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-destructive/10 mb-4">
            {getErrorIcon(errorInfo.errorType)}
          </div>

          {errorInfo.status && <ErrorStatusBadge status={errorInfo.status} />}

          <ErrorMessage
            title={errorInfo.title}
            message={errorInfo.message}
            suggestion={errorInfo.suggestion}
          />

          {error instanceof Error && <ErrorDetails error={error} />}

          <ErrorActions
            canRetry={errorInfo.canRetry}
            canGoBack={errorInfo.canGoBack}
            onRetry={onRetry}
            onGoBack={onGoBack}
          />
        </div>
      </div>
    </div>
  );
};
